import React, { useEffect } from 'react';

import { Navigate, Outlet } from 'react-router-dom';

import Loader from 'components/Loader/index';
import { useAppDispatch } from 'hooks/useAppDispatch';
import useAppNavigate from 'hooks/useAppNavigate';
import { AppRoutes } from 'routes/routes.enums';
import { getAccount, getBorrowerByID } from 'thunks/index';
import { getApplicationInfoForDashboardThunk } from 'thunks/getApplicationInfoForDashboard';
import { setAccount, setSignInStep, SignInStep } from 'actions/index';
import { resetAllSteps } from 'actions/stages';
import { useAppSelector } from 'hooks/useAppSelector';
import { applicationApi } from 'api/ApplicationApi';

const PrivateRoute = () => {
  const navigator = useAppNavigate();
  const [isLoading, setIsLoading] = React.useState(true);
  const refreshToken = localStorage.getItem('refreshToken');
  const dispatch = useAppDispatch();
  const {
    borrower: { borrowerId },
  } = useAppSelector((state) => state);
  const { applicationId } = useAppSelector((state) => state.application);
  const { sessionInfo } = useAppSelector((state) => state.account);

  const getInitialData = async () => {
    try {
      if (!refreshToken) {
        return;
      }

      const account = await dispatch(getAccount()).unwrap();
      const borrower = await dispatch(getBorrowerByID(account.borrowerId)).unwrap();

      dispatch(setAccount({ email: account.email, phone: account.phones[0]?.value }));

      if (sessionInfo?.isEmailNotVerified) {
        navigator(AppRoutes.Login);
        dispatch(setSignInStep(SignInStep.EnterConfirmationCode));

        return;
      }

      await dispatch(getApplicationInfoForDashboardThunk(borrower.id!)).unwrap();

      if (applicationId) {
        applicationApi.updateLoanPortalAccessTime(applicationId);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    dispatch(resetAllSteps());
    getInitialData();

    // we need login User only once when page is loaded
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  if (!refreshToken || !borrowerId) {
    return <Navigate to={AppRoutes.Login} />;
  }

  return <Outlet />;
};

export default PrivateRoute;
